import DeprecatedTeoActiveTextProvider from './TeoActiveTextProvider.svelte';
import { useActiveText, useTeoCore } from './teoAtom';

export { default as TeoContextProvider } from '../TeoProvider.svelte';
export { default as TeoProvider } from '../TeoProvider.svelte';
export {
  useTeoCore,
  useActiveText,
  TeoCore$,
  ActiveText$,
  teoAtom,
  teoCoreAtom,
  teoActiveTextAtom,
  onMountWithActiveText,
  onMountWithCore,
} from './teoAtom';
/**
 * @deprecated use useActiveText() instead
 */
export const TeoActiveTextProvider = DeprecatedTeoActiveTextProvider;

/**
 * @deprecated use useTeoCore() or useActiveText() instead
 */
export const useTeoContext = () => {
  return {
    get core() {
      return useTeoCore();
    },
    get activeText() {
      return useActiveText().current;
    },
  };
};
